import { getStatics } from '@/utils/statScoreApi';
import Vue from 'vue';
import i18n from '@/utils/i18n.js';

const defaultState = {
  statics: { loading: false, data: [] },
  matches: {
    played: 0,
    scheduled: 0,
    homeWin: 0,
    homePer: 0,
    draw: 0,
    drawPer: 0,
    awayWin: 0,
    awayPer: 0,
  },
  overUnder: [],
  goals: {
    scored: 0,
    avg: 0,
    homeGoalsScored: 0,
    homeGoalsScoredTitle: '',
    awayGoalsScored: 0,
    awayGoalsScoredTitle: '',
    homeGoalsScoredAvg: 0,
    homeGoalsScoredAvgTitle: '',
    awayGoalsScoredAvg: 0,
    awayGoalsScoredAvgTitle: '',
  },
  staticsNodes: [],
};
const state = {
  ...JSON.parse(JSON.stringify(defaultState)),
};

const getters = {};

const mutations = {
  setLoadingStatus(state, data) {
    state.statics = data.status
      ? { loading: data.status, data: [], error: data.error }
      : { ...state.statics, loading: false, error: data.error };
  },
  setDefaultState(state) {
    Object.keys(defaultState).forEach(key => {
      state[key] = defaultState[key];
    });
  },
  setStatics(state, data) {
    state.statics.data = data;
  },
  setMatches(state, data) {
    state.matches = data;
  },
  setOverUnder(state, data) {
    state.overUnder = data;
  },
  setGoals(state, data) {
    state.goals = data;
  },
  setStaticsNodes(state, data) {
    state.staticsNodes = data;
  },
};

const actions = {
  getStatics: ({ commit, rootState }, payload) => {
    commit('setDefaultState');
    commit('setLoadingStatus', { status: true });
    return getStatics({
      selectedLang: rootState.settings.selectedLocale.short_code,
      id: payload,
    })
      .then(res => {
        commit('setStatics', res.data.Data);

        let columns = res.data.Data.groups[0].participants[0].columns;
        let matches = {
          played: columns.find(item => item.id === 1).value,
          scheduled: columns.find(item => item.id === 68).value,
          homeWin: columns.find(item => item.id === 9).value,
          awayWin: columns.find(item => item.id === 15).value,
        };

        if (Vue.prototype.$statscoreHelper.isDrawable() && columns.find(item => item.id === 3)) {
          matches = {
            ...matches,
            draw: columns.find(item => item.id === 3).value,
          };
        }

        commit('setMatches', matches);

        if (['soccer-ball', 'SOC'].includes(Vue.prototype.$statscoreHelper.currentSport)) {
          let overUnder = [
            {
              title: '0.5',

              over: columns.find(item => item.id === 117),
              overPer: columns.find(item => item.id === 118).value,
              under: columns.find(item => item.id === 119),
              underPer: columns.find(item => item.id === 120).value,
            },
            {
              title: '1.5',
              over: columns.find(item => item.id === 113),
              overPer: columns.find(item => item.id === 114).value,
              under: columns.find(item => item.id === 115),
              underPer: columns.find(item => item.id === 116).value,
            },
            {
              title: '2.5',
              over: columns.find(item => item.id === 107),
              overPer: columns.find(item => item.id === 108).value,
              under: columns.find(item => item.id === 110),
              underPer: columns.find(item => item.id === 111).value,
            },
            {
              title: '3.5',
              over: columns.find(item => item.id === 400),
              overPer: columns.find(item => item.id === 401).value,
              under: columns.find(item => item.id === 404),
              underPer: columns.find(item => item.id === 405).value,
            },
            {
              title: '4.5',
              over: columns.find(item => item.id === 398),
              overPer: columns.find(item => item.id === 399).value,
              under: columns.find(item => item.id === 402),
              underPer: columns.find(item => item.id === 403).value,
            },
          ];

          commit('setOverUnder', overUnder);

          let goals = {
            scored: columns.find(item => item.id === 6).value,
            avg: columns.find(item => item.id === 102).value,
            homeGoalsScored: columns.find(item => item.id === 12),
            awayGoalsScored: columns.find(item => item.id === 30),
            homeGoalsScoredAvg: columns.find(item => item.id === 103),
            awayGoalsScoredAvg: columns.find(item => item.id === 104),
          };

          commit('setGoals', goals);
        }

        let staticsNodes = [];
        if (['nfl', 'NFL', 'basketball', 'NBA'].includes(Vue.prototype.$statscoreHelper.currentSport)) {
          staticsNodes.push({
            title: 'Props.StatScore.Scores',
            ...columns.find(item => item.code === 'avg_pts_scored'),
            childs: [
              {
                ...columns.find(item => item.code === 'home_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === 'away_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '1quart_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '2quart_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '3quart_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '4quart_avg_pts_scored'),
              },
            ],
          });
        }

        if (['hockey', 'NHL'].includes(Vue.prototype.$statscoreHelper.currentSport)) {
          staticsNodes.push(
            {
              title: 'Props.StatScore.Goals',
              ...columns.find(item => item.code === 'goals_scored'),
              childs: [
                {
                  ...columns.find(item => item.code === 'home_goals_scored'),
                },
                {
                  ...columns.find(item => item.code === 'away_goals_scored'),
                },
              ],
            },
            {
              title: 'Props.StatScore.Avarage Goals',
              ...columns.find(item => item.code === 'avg_goals_scored'),
              childs: [
                {
                  ...columns.find(item => item.code === 'avg_home_goals_scored'),
                },
                {
                  ...columns.find(item => item.code === 'avg_away_goals_scored'),
                },
                {
                  ...columns.find(item => item.code === '1per_avg_goals_scored'),
                },
                {
                  ...columns.find(item => item.code === '2per_avg_goals_scored'),
                },
                {
                  ...columns.find(item => item.code === '3per_avg_goals_scored'),
                },
              ],
            },
          );
        }

        if (['baseball', 'MLB'].includes(Vue.prototype.$statscoreHelper.currentSport)) {
          staticsNodes.push({
            title: 'Props.StatScore.Scores',
            ...columns.find(item => item.code === 'avg_pts_scored'),
            childs: [
              {
                ...columns.find(item => item.code === 'home_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === 'away_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '1inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '2inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '3inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '4inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '5inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '6inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '7inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '8inn_avg_pts_scored'),
              },
              {
                ...columns.find(item => item.code === '9inn_avg_pts_scored'),
              },
            ],
          });
        }

        commit('setStaticsNodes', staticsNodes);
        commit('setLoadingStatus', { status: false });
      })
      .catch(err => {
        console.log(err);
        commit('setLoadingStatus', { status: false, error: true });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
